// Version of the KVKK / privacy consent text the user agreed to at signup.
// Bump this whenever the KVKK Aydınlatma Metni / Gizlilik Sözleşmesi content
// changes, so records reflect which version each user accepted.
export const KVKK_CONSENT_VERSION = '1.0';

// Best-effort write of a KVKK consent record to a row that was just created.
// Never throws — if the consent columns don't exist yet (migration not applied)
// it logs a warning and lets registration continue normally.
export const recordConsent = async (supabase, table, id, acceptedAtIso) => {
    if (!id) return;
    try {
        const { error } = await supabase
            .from(table)
            .update({
                kvkk_accepted_at: acceptedAtIso || new Date().toISOString(),
                kvkk_version: KVKK_CONSENT_VERSION,
            })
            .eq('id', id);
        if (error) {
            console.warn(`[consent] KVKK onayı kaydedilemedi (${table}). Migration uygulanmış mı?`, error.message);
        }
    } catch (err) {
        console.warn(`[consent] KVKK onayı kaydedilemedi (${table}):`, err?.message);
    }
};
